'use client';

import { css } from '@flipster/styled-system/css';

import { zIndex } from './constants';

interface GamePieceProps {
  position: number;
  getCellPosition: (index: number) => { x: number; y: number };
  cellPercent: number; // cell size as percentage (e.g., 14.28 for 7 cells)
  skin?: string | null;
}

export const GamePiece = ({ position, getCellPosition, cellPercent, skin }: GamePieceProps) => {
  const cellPos = getCellPosition(position);
  const piecePercent = cellPercent;
  const left = cellPos.x + cellPercent / 2;
  const top = cellPos.y + cellPercent / 2;

  return (
    <div
      className={css({
        position: 'absolute',
        transition: 'left 0.3s ease-out, top 0.3s ease-out',
        zIndex: zIndex.piece,
        pointerEvents: 'none',
      })}
      style={{
        left: `${left}%`,
        top: `${top}%`,
        width: `${piecePercent}%`,
        height: `${piecePercent}%`,
        transform: 'translate(-50%, -50%)',
      }}
    >
      {skin ? (
        <img
          src={skin}
          alt='game piece'
          className={css({
            w: '100%',
            h: '100%',
            objectFit: 'contain',
            filter: 'drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3))',
          })}
        />
      ) : (
        <div
          className={css({
            w: '100%',
            h: '100%',
            bg: 'linear-gradient(135deg, #FFD700 0%, #FFA500 100%)',
            borderRadius: '50%',
            border: '2px solid #fff',
            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.3)',
          })}
        />
      )}
    </div>
  );
};
